
// const isDev = false;
// let BASE_URL = 'https://admin.dsspodapp.com/api';
// if(isDev){
//    BASE_URL = 'http://127.0.0.1:8000/api';
// }

// export const API_BASE_URL = BASE_URL;
// const isDev = true;

// let BASE_URL = 'https://admin.dsspodapp.com/api';

// if (isDev) {
//    BASE_URL = 'http://127.0.0.1:8000/api';
// }

// export const API_BASE_URL = BASE_URL;

const isDev = false;

let BASE_URL = 'https://adminpod.handydevs.com/api';

if (isDev) {
  BASE_URL = 'http://127.0.0.1:8000/api';
}

export const API_BASE_URL = BASE_URL;